// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__pVAwf","alignCenter":"Text_alignCenter__djqDS"};